var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "Message_list",
      staticClass: "Message",
      class: {
        "quote-focus":
          this.$store.state.chat.quoteMessageFocused &&
          this.$store.state.chat.quoteMessageFocused == _vm.message.messageId,
        "msg-selectable": _vm.selectable && _vm.isCustomerTextMessage,
        "msg-selected": _vm.selectable && _vm.selected,
        "msg-highlighted": _vm.highlighted
      },
      attrs: { id: "msg-" + _vm.message.messageId }
    },
    [
      !_vm.message.isType
        ? _c("div", { staticClass: "Message-Message-left" }, [
            _vm.selectable && _vm.isCustomerTextMessage
              ? _c(
                  "span",
                  {
                    staticClass: "msg-select-checkbox",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.toggleSelect($event)
                      }
                    }
                  },
                  [
                    _vm.selected
                      ? _c("span", { attrs: { "uk-icon": "check" } })
                      : _c("span", { staticClass: "unchecked-circle" })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "Message-Author" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.message.custNameNew == ""
                      ? _vm.message.custName
                      : _vm.message.custNameNew
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "bgImage",
                    rawName: "v-bgImage",
                    value: _vm.message.msg,
                    expression: "message.msg"
                  }
                ],
                staticClass: "Message-Content"
              },
              [
                _c(
                  "span",
                  { staticClass: "reply reply-left", on: { click: _vm.reply } },
                  [
                    _c("span", { attrs: { "uk-icon": "icon: reply;" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v(" Reply")])
                  ]
                ),
                _vm._v(" "),
                _vm.message.quotedMessageContent
                  ? _c(
                      "span",
                      {
                        staticClass: "quote-message",
                        on: {
                          click: function($event) {
                            return _vm.scrollToQuote(
                              _vm.message.quotedMessageId
                            )
                          }
                        }
                      },
                      [
                        _c("strong", [_vm._v("ข้อความ : ")]),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "msgChat",
                              rawName: "v-msgChat:html",
                              value: _vm.message.quotedMessageContent,
                              expression: "message.quotedMessageContent",
                              arg: "html"
                            }
                          ]
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "msgChat",
                      rawName: "v-msgChat:html",
                      value: _vm.message.msg,
                      expression: "message.msg",
                      arg: "html"
                    }
                  ],
                  staticClass: "msg"
                })
              ]
            ),
            _vm._v(" "),
            _c("small", {
              directives: [
                {
                  name: "time",
                  rawName: "v-time",
                  value: _vm.message.time,
                  expression: "message.time"
                }
              ]
            })
          ])
        : _c("div", { staticClass: "Message-Message-right" }, [
            _c("p", { staticClass: "Message-Author" }, [
              _c("strong", {
                directives: [
                  {
                    name: "nameChat",
                    rawName: "v-nameChat:html",
                    value: _vm.message,
                    expression: "message",
                    arg: "html"
                  }
                ]
              })
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "bgmsg",
                    rawName: "v-bgmsg",
                    value: _vm.message,
                    expression: "message"
                  }
                ],
                staticClass: "Message-Content"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "reply reply-right",
                    on: { click: _vm.reply }
                  },
                  [
                    _c("span", { attrs: { "uk-icon": "icon: reply;" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v(" Reply")])
                  ]
                ),
                _vm._v(" "),
                _vm.message.quotedMessageContent
                  ? _c(
                      "span",
                      {
                        staticClass: "quote-message",
                        on: {
                          click: function($event) {
                            return _vm.scrollToQuote(
                              _vm.message.quotedMessageId
                            )
                          }
                        }
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.message.quotedMessageSender.replace(
                                "{{customer}}",
                                "ลูกค้า"
                              )
                            ) + " : "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "msgChat",
                              rawName: "v-msgChat:html",
                              value: _vm.message.quotedMessageContent,
                              expression: "message.quotedMessageContent",
                              arg: "html"
                            }
                          ]
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.message.isUpload
                  ? _c("span", {
                      directives: [
                        {
                          name: "msgChat",
                          rawName: "v-msgChat:html",
                          value: _vm.message.msg,
                          expression: "message.msg",
                          arg: "html"
                        }
                      ],
                      staticClass: "msg"
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "small",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.message.pushStatus === "failed",
                    expression: "message.pushStatus === 'failed'"
                  }
                ],
                staticClass: "error-status"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "retry-btn",
                    attrs: { title: "ลองส่งอีกครั้ง" },
                    on: {
                      click: function($event) {
                        return _vm.fnReSendMessage(_vm.message)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-redo" }),
                    _vm._v(" ลองใหม่\n      ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "remove-btn",
                    attrs: { title: "ลบข้อความ" },
                    on: {
                      click: function($event) {
                        return _vm.fnRemoveMessage(_vm.message)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "error-text" }, [
                  _vm._v(_vm._s(_vm.message.pushError || "การส่งข้อมูลผิดพลาด"))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "small",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.message.pushStatus === "pending",
                    expression: "message.pushStatus === 'pending'"
                  }
                ],
                staticClass: "pending-status"
              },
              [
                _c("i", { staticClass: "fas fa-spinner fa-spin" }),
                _vm._v(" กำลังส่ง...\n    ")
              ]
            ),
            _vm._v(" "),
            _c("small", {
              directives: [
                {
                  name: "time",
                  rawName: "v-time",
                  value: _vm.message.time,
                  expression: "message.time"
                }
              ]
            })
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb6f00f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb6f00f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatMessage.vue
// module id = null
// module chunks = 